import Component from '@glimmer/component';

import date from 'rise-ui/helpers/date.js';
import dateParse from 'rise-ui/helpers/date-parse.js';
import nom from 'rise-ui/helpers/nom.js';
import notFalse from 'rise-ui/helpers/not-false.js';
import or from 'rise-ui/helpers/or.js';
import utcOffset from 'rise-ui/helpers/utc-offset.js';

export default class DateRangeDisplaySimpleComponent extends Component {
  <template>
    {{#let
      (or @dateFormat "short")
      (dateParse @fromDate)
      (dateParse @toDate)
      (notFalse @parens)
      as | dateFormat fromDate toDate parens |
    ~}}
    <span class="c-date-range-display-simple" ...attributes>
      <span class="c-date-range-display-simple__from-date-part">
        {{~if parens "("~}}
        {{~#if fromDate~}}
          <span class="c-date-range-display-simple__from-date"
          >{{date (utcOffset fromDate) dateFormat}}</span>
        {{~else~}}
          <span
            class="c-date-range-display-simple__from-date c-date-range-display-simple__from-date--empty"
          ></span>
        {{~/if}}
      </span>
      {{~nom~}}
      <span class="c-date-range-display-simple__to-date-part">
        to
        {{#if toDate~}}
          <span class="c-date-range-display-simple__to-date"
          >{{date (utcOffset toDate) dateFormat}}</span>
        {{~else~}}
          <span
            class="c-date-range-display-simple__to-date c-date-range-display-simple__to-date--empty"
          ></span>
        {{~/if~}}
        {{~if parens ")"~}}
      </span>
    </span>
    {{~/let~}}
  </template>
}
